import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["type", "invoice"];

  connect() {
    if (this.typeTarget.value === "invoice") {
      this.invoiceTarget.classList.remove("hidden");
    } else {
      this.invoiceTarget.classList.add("hidden");
    }
  }

  typeChanged(event) {
    if (event.target.value === "invoice") {
      this.invoiceTarget.classList.remove("hidden");
    } else {
      this.invoiceTarget.classList.add("hidden");
    }
  }
}
